<!-- 设备管理 -->
<template>
  <div class="dm_home flex_row apphome">
    <!-- <leftcolumn class="app5760 flex_column"/> -->
    <div class="left flex_column">
      <div class="top">
        <div class="mybox">
          <div class="title">重点设备<span class="more el-icon-more" @click="importantDevShow"></span></div>
          <div class="box keyequipment">
            <vue-seamless-scroll :class-option="{limitMoveNum: 4,direction: 1,step: 0.6}" :data="keyequipment" class="warp">
            
            
              <li v-for="(item, index) in keyequipment" :key="index">
                <img :src="item.src">
                <div class="right">
                  <div class="title">{{item.title}}</div>
                  <div class="text">{{item.text}}</div>
                </div>
              </li>
            </vue-seamless-scroll>

          </div>
        </div>
      </div>
      <div class="bottom flex_column">
        <div class="mybox">
          <div class="title">新装设备<span class="more el-icon-more" @click="newImportantDevShow"></span></div>
          <div class="box newequipment">
            <div class="title">{{newequipment.title}}</div>
            <div class="text">{{newequipment.text}}<img :src="newequipment.src"></div>
          </div>
        </div>
        <div class="mybox">
          <div class="title">设备状态</div>
          <div class="box">
            <DeviceStatus></DeviceStatus>
          </div>
        </div>
      </div>
    </div>
    <div class="center flex_column">
      <div class="top">
        <div class="mybox">
          <!-- <div class="title">实时状态</div> -->
          <div class="box realtime" ref="iframeHeight">
            <div class="imgbox" :style="{height:iHeight+ 'px'}">
              <iframe v-if="configurationMap" width="100%" height="100%" :src="configurationMap" frameborder="0"></iframe>
              <img v-else src="@/assets/images/noZutai.png" alt="" class="noimg">
            </div>
            <RealTimeStatus v-if="openWin" v-bind:deviceId="deviceId"></RealTimeStatus>
          </div>
        </div>
      </div>
      <div class="bottom flex_column">
          <div class="mybox">
            <div class="title">运行记录
              <div class="tabtitle">
                <li @click="$refs.KeyEquipment.setActiveItem(index)" v-for="(item,index) in recordList" :key="index" :class="item.devName==toFatherName?'active':''">{{item.devName}}</li>
              </div>
            </div>
            <div class="box">
              <KeyEquipment ref="KeyEquipment" @nowName="nameChange" />
            </div>
          </div>
          <div class="mybox">
            <div class="title">物联网设备 <span @click="$refs.wlwboxdialog.openDialog()" class="more el-icon-more"></span></div>
            <div class="box wlwbox">
              <div>
                <!-- <div class="title">信号点</div> -->
                <div class="left">
                  <div id="dm_bar1" class="echarts"></div>
                  <div class="text"><b>{{signalOnline}}</b>/{{signalTotal+signalOnline}}个</div>
                </div>
                <div class="right right2">
                  <div id="dm_pie3" ref="dm_pie3" class="echarts"></div>


      
                </div>
              </div>
              <div>
                <!-- <div class="title">采集点</div> -->
                <div class="left">
                  <div id="dm_bar2" class="echarts"></div>
                  <div class="text"><b>{{collectOnline}}</b>/{{collectTotal+collectOnline}}个</div>
                </div>
                <div class="right">
                  <div id="dm_pie1" class="echarts"></div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="right flex_column">
      <div class="mybox">
        <div class="title">运行提示</div>
        <div class="box yxlist">
          <li @click="yxRowClick(item)" v-for="(item, index) in yxlist" :key="index">
            <i class="el-icon el-icon-warning"></i>
            <span>{{item.name}}</span>
            <span>{{item.type}}</span>
            <span>{{item.time}}</span>
          </li>
        </div>
      </div>
      <div class="mybox">
        <div class="title">运维团队</div>
        <div class="box ywbox">
          <DefTree v-bind:tree="treeDatas"></DefTree>
        </div>
      </div>
      <div class="mybox">
        <div class="title">设备检修计划</div>
        <div class="box jxjhlist">
          <li v-for="(item, index) in jxjhlist" :key="index">
            <span>{{item.time}}</span><span>{{item.quyu}}</span><span>{{item.name}}</span>
            <span>{{item.type}}</span><span>{{item.user}}</span>
          </li>
        </div>
      </div>
      <div class="mybox">
        <div class="title">备件更换率</div>
        <div class="box">
          <div id="dm_bar4" class="echarts"></div>
        </div>
      </div>
    </div>
    <!-- <rightcolumn class="app5760 flex_column"/> -->


<!-- 重点设备弹窗 -->
    <el-dialog v-dialogDrag title="设备信息" :close-on-click-modal="false" :visible.sync="keyequipmentdialog" class="keyequipmentdialog">
      <div class="dialogcontent">
        <div class="left">
          <li @click="imporatantClick(item.id)" :class="item.id==linshiID?'active':''" v-for="(item,index) in imporatantDevList" :key="index">{{item.devName}}</li>
        </div>
        <div class="right">
          <div class="title">{{importantDevDetalis.devName}}</div>
          <div class="text">
            <img :src="importantDevDetalis.devImg"/>{{importantDevDetalis.devRemark}}
          </div>
        </div>
      </div>
    </el-dialog>
<!-- 新装设备弹窗 -->
    <el-dialog v-dialogDrag title="设备信息" :close-on-click-modal="false" :visible.sync="newDeviceDialog" class="keyequipmentdialog">
      <div class="dialogcontent">
        <div class="left">
          <li @click="newImporatantClick(item.id)" :class="item.id==newLinshiID?'active':''" v-for="(item,index) in newImporatantDevList" :key="index">{{item.devName}}</li>
        </div>
        <div class="right">
          <div class="title">{{newImportantDevDetalis.devName}}</div>
          <div class="text">
            <img :src="newImportantDevDetalis.devImg"/>{{newImportantDevDetalis.devRemark}}
          </div>
        </div>
      </div>
    </el-dialog>
<!-- 运行提示弹窗 -->
    <el-dialog v-dialogDrag title="运行提示信息" :close-on-click-modal="false" :visible.sync="yxlistdialog" class="yxlistdialog">
      <div class="dialogcontent">
        <div class="form">
          <div class="el-col12 item"><label>提示时间：</label><span>{{yxRowDeatailsData.eventTime}}</span></div>
          <div class="el-col12 item"><label>事件类型：</label><span>{{
            yxRowDeatailsData.eventCase==1?'安全提示':
            yxRowDeatailsData.eventCase==2?'管理提示':
            yxRowDeatailsData.eventCase==3?'能耗突增':'能耗超标'}}
            </span>
          </div>
          <div class="el-col12 item"><label>事件主题：</label><span>{{yxRowDeatailsData.eventBody}}</span></div>
          <div class="el-col12 item"><label>发生区域：</label><span>{{yxRowDeatailsData.eventArea}}</span></div>
          <div class="el-col24 item"><label>事件内容：</label><span>{{yxRowDeatailsData.content}}</span></div>
        </div>
      </div>
    </el-dialog>
    <!-- 物联网设备弹窗 -->
    <wlwboxdialog ref="wlwboxdialog"/>
  </div>
</template>

<script>
import api from '@/apis/device/device'
let echarts = require("echarts/lib/echarts");
import DefTree from '@/components/TreeDefault'
import RealTimeStatus from "../../components/RealTimeStatus";//实时状态
import DeviceStatus from "../../components/DeviceStatus";//设备状态
import KeyEquipment from "../../components/KeyEquipment";//运行记录

// import leftcolumn from "@/views/CompanyProfile/leftcolumn.vue";
// import rightcolumn from "@/views/CompanyProfile/rightcolumn.vue";
import wlwboxdialog from './wlwboxdialog.vue'
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  components: {
    vueSeamlessScroll,
    RealTimeStatus,DeviceStatus,KeyEquipment,DefTree,
    // leftcolumn,
    // rightcolumn,
    wlwboxdialog
  },
  data() {
    return {
      //重点设备
      keyequipmentdialog:false,
      imporatantDevList:[],//重点设备列表数据
      linshiID:'',//重点设备临时id
      importantDevDetalis:'',//重点设备详情
      //运行记录
      recordList:[],//运行记录设备数据
      toFatherName:'',//传过来的name
      //运行提示
      yxRowDeatailsData:'',
      yxlistdialog:false,

      //物联网设备弹框
      wlwboxdialog:false,
      //组态
      configurationMap:'',//组态图
      iHeight:'',
      openWin:false,

      propmtSataus:["安全提示","管理提示","能耗突增","能耗超标"],
      devInspect:["常规保养","损坏维修","其他"],
      yxlist:'',
      jxjhlist:'',
      keyequipment:[],
      //新装设备
      newequipment:{
        title:'',
        text:'',
        src:'',
      },
      newDeviceDialog:false,
      newImporatantDevList:[],//重点设备列表数据
      newLinshiID:'',//重点设备临时id
      newImportantDevDetalis:'',//重点设备详情
      //信号点
      signalTotal:'',
      signalOnline:'',
      //采集点
      collectTotal:'',
      collectOnline:'',
      //树数据
      treeDatas:'',

    };
  },
  methods: {
    //运行提示点击事件
    yxRowClick(row){
      api.getPromptDetails(row.id).then(res=>{
        if(res.data){
          this.yxRowDeatailsData = res.data
          this.yxlistdialog = true;
        }
      })
    },
    //获取运行记录设备
    getRecordDev(){
      api.getRecord({
        params: {
          limit: 5,
        }
      }).then(res=>{
        if(res.data.length!=0){
          this.recordList = res.data
          this.toFatherName = res.data[0].devName
        }
      })
    },
    //运行记录幻灯片切换
    nameChange(val){
      this.toFatherName = val
    },
    //重点设备点击事件
    imporatantClick(id){
      this.linshiID = id
      api.getStressDetails(id).then(res=>{
        if(res.data){
          this.importantDevDetalis = res.data
        }
      })
    },
    //重点设备弹框
    importantDevShow(){
      this.keyequipmentdialog = true
      api.getStress().then(res=>{
        if(res.data.length!=0){
          this.imporatantDevList = res.data
          this.linshiID = res.data[0].id
          this.imporatantClick(res.data[0].id)
        }
      })
    },


    //获取树数据
    getTree(){
      api.getOpsTeam().then(res=>{
        if(res.code==10000){
          if(res.data.length!=0){
            this.treeDatas = res.data
          }
        }
      })
    },
    //获取实时状态
    getZuTai(){
      api.getConfig().then(res=>{
        if(res.data.list.length!=0){
          this.configurationMap = res.data.list[0].confUrl
        }
      })
    },
    //获取重点装备
    getImpDevice(){
      api.getStress({
        params: {
          limit: 5,
          page: 1,
        },
      }).then(res=>{
        if(res.code==10000){
          let _data = res.data
          let _arr = _data.map(item=>{
            return{
              id:item.id,
              title:item.devName,
              src:item.devImg,
              text:item.devRemark,
            }
          })
          this.keyequipment = _arr
        }
      })
    },
    //获取新装设备
    getNewDevice(){
      api.getNewDev().then(res=>{
        if(res.data.length!=0){
          let _data = res.data[0]
          this.newequipment.title = _data.devName
          this.newequipment.text = _data.devRemark
          this.newequipment.src = _data.devImg
        }
      })
    },
    //新装设备点击事件
    newImporatantClick(id){
      this.newLinshiID = id
      api.getNewDevDetails(id).then(res=>{
        if(res.data){
          this.newImportantDevDetalis = res.data
        }
      })
    },
    //新装设备弹框
    newImportantDevShow(){
      this.newDeviceDialog = true
      api.getNewDev().then(res=>{
        if(res.data.length!=0){
          this.newImporatantDevList = res.data
          this.newLinshiID = res.data[0].id
          this.newImporatantClick(res.data[0].id)
        }
      })
    },

    //获取物联网设备
    getWLAN(){
      api.getIot().then(res=>{


        if(res.code==10000){
          let _data = res.data
 
          this.signalTotal =  _data['离线']?_data['离线']:0
          this.signalOnline = _data['在线']?_data['在线']:0

          this.collectTotal =   _data['离线']?_data['离线']:0
          this.collectOnline =  _data['在线']?_data['在线']:0

          let sum =  this.collectTotal+this.collectOnline

          this.dm_pie2('dm_bar1',(_data['在线']/sum*100).toFixed(0));
          this.dm_pie2('dm_bar2',(_data['在线']/sum*100).toFixed(0));
          this.dm_pie1(
            _data['电参量'],
            _data['水量'],
            _data['燃气'],
            _data['电气火灾'],
            _data['温度'],
            _data['电气火灾含电参量'],
            _data['基站电池'],
            _data['制冷设备'],
            _data['环境'],
          )

          this.myfun1(
            _data['2G无线网络'],
            _data['3G无线网络'],
            _data['4G无线网络'],
            _data['5G无线网络'],
            _data['wifi传输'],
            _data['有线传输'],
          )


        }else{
          this.$message.error(res.message)
        }

        
      })
    },
    //获取备件更换率
    getBJChange(){
      api.getSpare().then(res=>{
        if(res.code==10000){
          let _data = res.data.list
          let name = []
          let rate = []
          let avg = []
          for(var i in _data){
            name.push(_data[i].spareName)
            rate.push(_data[i].onReplace)
            avg.push(_data[i].tradeReplace)
          }
          this.dm_bar4(name,rate,avg)
        }
      })
    },
    //获取运行提示
    getRunPropmt(){
      api.getPrompt().then(res=>{
        if(res.code==10000){
          let _data = res.data
          let _arr = _data.map(item=>{
            return{
              id:item.id,
              name:item.eventBody,
              type:this.propmtSataus[item.eventCase-1],
              time:item.eventTime,
            }
          })
          this.yxlist = _arr.reverse()
        }
      })
    },
    //获取设备检修计划
    getDevSecviec(){
      api.getInspect().then(res=>{
        if(res.code==10000){
          let _data = res.data
          let _arr = _data.map(item=>{
            return{
              id:item.id,
              time:item.inspectTime,
              quyu:item.devArea,
              name:item.devName,
              type:this.devInspect[item.inspectType-1],
              user:item.inspectUser,
            }
          })
          this.jxjhlist = _arr.reverse()
        }
      })
    },
    dm_pie1(c1,c2,c3,c4,c5,c6,c7,c8,c9){
      let dm_pie1 = echarts.init( document.getElementById('dm_pie1') );
      dm_pie1.setOption({
          color:['#00ccff','#24ffb1','#fff45c','#f4af1b','#ae74f3','#ff5f8c','#3570ff','#094','#f95458'],
          tooltip: {
              trigger: 'item',textStyle:{fontSize: this.$echartsFontSize},
          },
          legend: {
              show:false
          },
          series: [
              {
                  // name: '访问来源',
                  type: 'pie',
                  radius: ['33%', '45%'],
                  center:['50%','54%'],
                  label: {
                      show: true,color:'#ccd0f2',fontSize:this.$echartsFontSize-4,
                      formatter: '{b}\n{num|{c}}', lineHeight:this.$echartsFontSize,
                      rich: {
                          num: {
                              color: '#fff',fontSize:this.$echartsFontSize-2
                          }
                      }
                  },
                  data: [
                      {value: c1, name: '电参量'},
                      {value: c2, name: '水量'},
                      {value: c3, name: '燃气'},
                      {value: c4, name: '电气火灾'},
                      {value: c5, name: '温度'},
                      {value: c6, name: '电气火灾含电参量'},
                      {value: c7, name: '基站电池'},
                      {value: c8, name: '制冷设备'},
                      {value: c9, name: '环境'},
                  ]
              }
          ] 
      })
    },
    dm_pie2(id,data){
  
      let dm_pie2 = echarts.init( document.getElementById(id) );
      dm_pie2.setOption({
          color:['#24ffb1'],
          tooltip: {
              trigger: 'item',textStyle:{fontSize: this.$echartsFontSize},
          },
          legend: {
              show:false
          },
          title: [{
              text: '在线率',
              x: 'center',
              top: '55%',
              textStyle: {
                  color: '#24ffb1',
                  fontSize:this.$echartsFontSize+2,
                  fontWeight: '100',
              }
          }, {
              text: isNaN(data)?0:data+'%',
              x: 'center',
              top: '40%',
              textStyle: {
                  fontSize:this.$echartsFontSize+14,
                  color: '#24ffb1',
                  fontWeight: '600',
              },
          }],
          polar: {
              radius: ['40%', '50%'],
              center: ['50%', '50%'],
          },
          angleAxis: {
              max: 100, show: false,
          },
          radiusAxis: {
              type: 'category',
          },
          series: [
              {
                  type: 'bar',
                  roundCap: true, barWidth: 60,
                  showBackground: true,
                  backgroundStyle: {
                      color: 'rgba(255, 255, 255, .2)',
                  },
                  data: [isNaN(data)?0:data],
                  coordinateSystem: 'polar'
              }
          ] 
      })
    },
    myfun1(a1,a2,a3,a4,a5,a6) {
      var chartDom = this.$refs.dm_pie3;
      var myChart = echarts.init(chartDom);



      var option = {
          color:['#00ccff','#24ffb1','#fff45c','#f4af1b','#ae74f3','#ff5f8c','#3570ff','#094','#f95458'],
          tooltip: {
            trigger: 'item',textStyle:{fontSize: this.$echartsFontSize},
          },
          legend: {
            show:false
          },
          series: [
              {
                  // name: '访问来源',
                  type: 'pie',
                  radius: ['33%', '45%'],
                  center:['50%','54%'],
                  label: {
                      show: true,color:'#ccd0f2',fontSize:this.$echartsFontSize-4,
                      formatter: '{b}\n{num|{c}}', lineHeight:this.$echartsFontSize,
                      rich: {
                        num: {
                          color: '#fff',fontSize:this.$echartsFontSize-2
                        }
                      }
                  },
                  data: [
                      {value: a1, name: '2G无线网络'},
                      {value: a2, name: '3G无线网络'},
                      {value: a3, name: '4G无线网络'},
                      {value: a4, name: '5G无线网络'},
                      {value: a5, name: 'wifi传输'},
                      {value: a6, name: '有线传输'},
     
                  ]
              }
          ] 
      };
      myChart.setOption(option);
    },
    dm_bar4(a,b,c){
      let dm_bar4 = echarts.init( document.getElementById('dm_bar4') );
      dm_bar4.setOption({
        color:['#00ccff','#24ffb1'],
        tooltip: {
          trigger: 'axis',textStyle:{fontSize: this.$echartsFontSize},
          axisPointer: {
            type: 'shadow'
          },
          formatter: '{b}<br />实际更换率：{c0} % <br/>平均更换率：{c1} %'
        },
        legend: {
            data: ['实际更换率', '平均更换率'],
            left: 'center', top:10,
            textStyle: {
                color: "#fff",fontSize:this.$echartsFontSize
            },
            itemWidth: 15,itemHeight: 5,
        },
        grid: {
          left: "5%", right: "5%", top: "20%", bottom: "2%",
          containLabel: false,
        },
        xAxis: {
          type: "value",show: false,
        },
        yAxis: {
          type: "category", show:true,
          data: a,
        },
        series: [
          {
            name: "实际更换率",
            type: "bar",
            barWidth: "22%",
            itemStyle: {
              normal: { 
                label: { show: false},
                barBorderRadius: [0,0,0,0],
              }
            },
            data: b,
          },
          {
            name: "平均更换率",
            type: "bar",
            barWidth: "22%",barGap:'10%',
            itemStyle: {
              normal: { 
                label: { show: true, 
                  position:[10,'-6px'],formatter: '{b}',lineHeight:'15',color:'#fff',fontSize:this.$echartsFontSize+4,
                  textShadowColor:'#000',textShadowBlur:4, textShadowOffsetX:1, textShadowOffsetY:1
                },
                barBorderRadius: [0,0,0,0],
              }
            },
            data: c,
          },
        ],
      })
      this.$common.moveEcharts(a.length,dm_bar4);
   },


  },
  mounted() {
    //获取高度
    var _iHeight = this.$refs.iframeHeight.offsetHeight
    this.iHeight = _iHeight


    // var _that = this;
    // //iframe监听
    // window.addEventListener('message', function(e) {
    //   if(e.origin!='http://'+window.location.host){
    //     _that.deviceId = e.data
    //     _that.openWin = !_that.openWin;
    //   }
    // },false);


    //获取运行记录设备
    this.getRecordDev()
    //获取实时状态
    this.getZuTai()
    //获取重点装备
    this.getImpDevice()
    //获取新装设备
    this.getNewDevice()
    //获取物联网设备
    this.getWLAN()
    //获取备件更换率
    this.getBJChange()    
    //获取运行提示
    this.getRunPropmt()
    //获取设备检修计划
    this.getDevSecviec()
    //获取树数据
    this.getTree()
  },
};
</script>

<style lang="less" scoped>
.dm_home {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0 0.5rem 0.5rem;
  & > .left {
    height: 100%;
    overflow: hidden;
    width: 25%;
    & > .top,
    & > .bottom {
      height: 50%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      .mybox {
        flex: 1;
        height: 50%;
        overflow: hidden;
      }
    }
  }
  & > .center {
    height: 100%;
    overflow: hidden;
    width: 50%;
    & > .top,
    & > .bottom {
      height: 50%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      .mybox {
        flex: 1;
        height: 50%;
        overflow: hidden;
      }
    }
  }
  & > .right {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      height: 25%;
      overflow: hidden;
    }
  }
  .realtime{ position: relative;}
  .yxlist{ display: flex; flex-direction: column; padding:10px 15px;
    li{ padding:.5rem 15px; width: 100%; display: flex; flex-direction: row; align-items: center;
      i{ color: #f4af1b; position: relative; top:1px; margin-right: 10px; font-size: .9rem;}
      span{ text-overflow:ellipsis; white-space: nowrap; overflow: hidden;}
      span:nth-child(2){ flex:1;}
      span:nth-child(3){ width: 6rem; text-align: center;}
      span:nth-child(4){ width: 8rem; text-align: right;}
    }
    li:nth-child(odd){ background: #ffffff10;}
  }
  .ywbox{ width: 100%; height: 100%; overflow: auto; display: flex; justify-content: center;}
  .jxjhlist{ display: flex; flex-direction: column; padding:10px 15px;
    li{ padding:.5rem 15px; width: 100%; display: flex; flex-direction: row; align-items: center;
      span{ text-overflow:ellipsis; white-space: nowrap; overflow: hidden;}
      span:nth-child(1){ width: 5rem; text-align: left;}
      span:nth-child(2){ flex:1; text-align: center;}
      span:nth-child(3){ flex:1; text-align: center;}
      span:nth-child(4){ width: 4rem; text-align: center;}
      span:nth-child(5){ width: 3rem; text-align: right;}
    }
    li:nth-child(odd){ background: #ffffff10;}
  }
  .keyequipment{ 
    // display: flex;
   flex-direction: column; padding:.3rem;
    li{ margin: .3rem; height: 33%; overflow: hidden; padding-bottom: .6rem; border-bottom: #1643b4 dashed 1px; display: flex; flex-direction: row;
      img{ width: 9rem; height: 100%; flex-shrink: 0;}
      .right{ flex:1; padding:0 .9rem; vertical-align: top; width: 100%; overflow: hidden;
        .title{ font-size: .8rem; margin: .3rem 0 .4rem; color: #05f8fc; text-overflow:ellipsis; white-space: nowrap; overflow: hidden;}
        .text{ flex: 1; height: 100%; line-height: 1rem; overflow: hidden;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 6; text-overflow:ellipsis; white-space: wrap; text-indent: 1.5rem;}
      }
    }
    li:last-child{ border: none; padding-bottom: 0;}
  }
  .newequipment{ display: flex; flex-direction: column; padding:.4rem .8rem .8rem;
    .title{ font-size: .8rem; margin: .3rem 0 .6rem; color: #05f8fc; text-overflow:ellipsis; white-space: nowrap; overflow: hidden;}
    .text{ flex: 1; height: 100%; line-height: 1rem; overflow: hidden;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 9; text-overflow:ellipsis; white-space: wrap;text-indent: 1.5rem; padding-right:9.5rem; position: relative;}
    img{ width: 9rem; position: absolute; top:0; right:0; height:100%;}
  }
  .wlwbox{ display: flex; flex-direction: row; padding:.3rem;
    &>div{ flex:1; width: 50%; margin:.3rem; overflow: hidden; position: relative; background: #0c1c4aa6; border-radius: 10px;
      .title{ padding:10px 0; text-align: center; position: absolute; width: 20%; left:50%; margin-left: -10%; top: .6rem; color: #24ffb1; border: #05f8fc dashed 1px; border-radius: 8px;}
      .left{ display: inline-block; width: 40%; position: relative; height: 100%;
        .text{ text-align: center; width: 100%; position: absolute; bottom:.5rem;
          b{ font-size: 1.2rem; color: #24ffb1;}
        }
      }
   
      .right{ display: inline-block; width: 60%; height: 100%; position: relative;}

      // .right2{
      //   width: 30%;
      // }    
      .chartDataS{
        position: absolute;
        top: 20%;
        right: 14%;
        line-height: 1.2rem;
        .spot{
          font-size: 2rem;
        }
      }
    }
  }

  .mybox>.title>.tabtitle{ position: absolute; top:2px; right:.1rem;
    li{ display: inline-block; margin-left:0.25rem; padding:0 .5rem; font-size: .8rem; cursor: pointer;}
    li:hover{ color: #24ffb1;}
    li.active{ color: #fff; background: #0d2748; border-radius: 0.25rem;}
  }


}


  


.imgbox{position: relative;}
.imgbox img{ width: 100%; height: 100%;}
.imgbox .noimg{ position: absolute; top:50%; left:50%; margin-top:-221px; margin-left:-198px; width: 398px; height: 442px; transform: scale(.5);}
</style>
<style lang="less">
  .keyequipmentdialog .el-dialog,.wlwboxdialog .el-dialog{ width: 60rem;
    .dialogcontent{ display: flex; flex-direction: row; padding:.5rem; height: 35rem; overflow: hidden;
      .left{ width: 13rem; flex-shrink: 0; border: #0c2667 solid 1px; padding:.5rem; margin-right: 1rem; height: 100%; overflow-y: auto;
        li{ height: 1.8rem; color: #fff; padding:0 .5rem; line-height: 1.8rem; cursor: pointer; margin-bottom: .2rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;}
        li.active{ color: #24ffb1; background: rgba(24, 255, 106, .1); border: #24ffb1 dashed 1px;}
        li:hover{ color: #24ffb1;}
      }
      .right{ flex: 1; width: 100%; overflow: hidden; display: flex; flex-direction: column;
        .title{ color: #24ffb1; font-size: .9rem; border-bottom: #24ffb1 dashed 1px; text-align: center; line-height: 2rem; margin-bottom: 1rem;}
        .text{ line-height: 1rem; display: flex; flex-direction: row; flex: 1; height: 100%; overflow-y: auto;
          img{ width: 10rem; margin-right: 1rem; height: 10rem;}
        }
      }
    }
  }
  .yxlistdialog .el-dialog{ width: 40rem;
    .dialogcontent{ padding:.5rem; height: 15rem; overflow: hidden;
      .form{ width: 100%; overflow-y: auto; display: flex; flex-direction: row; flex-wrap: wrap; 
        .el-col12{ width: 50%; flex-shrink: 0;}
        .el-col24{ width: 100%; flex-shrink: 0;}
        .item{ border-bottom: #555e86 dashed 1px; padding:.4rem .5rem; display:flex; flex-direction: row;
          label{ width: 4rem; flex-shrink: 0; text-align: right; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 10px;}
          span{ color: #fff;}
        }
        .item:last-child{ border-bottom: none;}
      }
    }
  }
  .wlwboxdialog .el-dialog{ width: 65rem;
    .dialogcontent{ 
      .left{ 
        li{ 
          span{ background: #3570ff; border-radius: 6px; color: #fff; padding:0 8px 1px; margin-right: 15px;}
          span.red{ background: #ff5f8c;}
        }
      }
      .right{ flex: 1; width: 100%; overflow: hidden; display: flex; flex-direction: column;
        .el-tabs__nav-wrap::after{ background-color: #3570ff;}
        .el-tabs__active-bar{ background-color: #24ffb1; height: 4px;}
        .el-tabs--top .el-tabs__item{ font-size: .8rem; height: 2rem; line-height: 2rem;}
        .el-tabs--top .el-tabs__item.is-active{ color: #24ffb1;}
        .el-tab-pane{ height: 100%; display: flex; flex-direction: row; overflow: hidden; align-items: baseline;}
        .img{ width: 22rem; margin-right: 1rem; flex-shrink: 0;
          h3{ font-size: .8rem; color: #24ffb1;}
        }
        .form{ flex: 1; height: 100%; width: 100%; overflow-y: auto;
          .item{ border-bottom: #555e86 dashed 1px; padding:.4rem .5rem; display:flex; flex-direction: row;
            label{ width: 5rem; flex-shrink: 0; text-align: right; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 10px;}
            span{ color: #fff;}
          }
          .item:last-child{ border-bottom: none;}
        }
      }
    }
  }
</style>
